import { articleBrandsSlice } from "./articleBrandsSlice";
import * as actions from "./articleBrandsActions";
import * as selectors from "./articleBrandsSelectors";

export { actions };
export { selectors };
export default articleBrandsSlice.reducer;
